import Player from "../services/player";

const player1 = new Player(
    [
        2872, 2872, 2862, 2862, 2863, 2863, 2863, 2863, 2863, 2863, 2863, 2862,
        2862, 2862, 2862, 2847, 2847, 2847, 2847, 2847, 2847, 2855, 2855, 2855,
        2856, 2865, 2865, 2864, 2864, 2864, 2864, 2864, 2864, 2861, 2856, 2859,
        2859, 2859, 2852, 2852, 2853, 2853, 2853, 2835, 2835, 2839, 2839, 2829,
        2830, 2830,
    ],
    "Magnus Carlsen"
);

const player2 = new Player(
    [
        2822, 2822, 2842, 2842, 2835, 2835, 2835, 2835, 2835, 2835, 2828, 2823,
        2823, 2823, 2823, 2820, 2820, 2820, 2820, 2806, 2806, 2800, 2800, 2791,
        2792, 2792, 2792, 2781, 2781, 2786, 2783, 2783, 2776, 2758, 2763, 2766,
        2766, 2766, 2766, 2766, 2764, 2764, 2773, 2782, 2782, 2786, 2786, 2795,
        2794, 2804,
    ],
    "Fabiano Caruana"
);

const player3 = new Player(
    [
        2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736,
        2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736, 2736,
        2736, 2736, 2736, 2750, 2750, 2760, 2760, 2760, 2768, 2768, 2768, 2768,
        2768, 2768, 2768, 2768, 2775, 2775, 2775, 2787, 2787, 2780, 2780, 2778,
        2788, 2788,
    ],
    "Hikaru Nakamura"
);

const player4 = new Player(
    [
        2801, 2805, 2805, 2805, 2791, 2791, 2791, 2791, 2791, 2791, 2791, 2791,
        2791, 2791, 2791, 2791, 2791, 2799, 2799, 2799, 2799, 2799, 2799, 2799,
        2799, 2799, 2799, 2799, 2799, 2806, 2806, 2806, 2808, 2808, 2811, 2811,
        2811, 2811, 2788, 2788, 2788, 2789, 2780, 2780, 2780, 2780, 2780, 2780,
        2780, 2780,
    ],
    "Ding Liren"
);

const player5 = new Player(
    [
        2767, 2774, 2774, 2774, 2784, 2784, 2784, 2784, 2784, 2784, 2784, 2784,
        2784, 2789, 2789, 2789, 2789, 2792, 2792, 2792, 2792, 2792, 2782, 2782,
        2782, 2773, 2773, 2773, 2773, 2773, 2766, 2766, 2792, 2792, 2793, 2793,
        2793, 2793, 2793, 2795, 2795, 2794, 2779, 2779, 2779, 2771, 2771, 2771,
        2771, 2769,
    ],
    "Ian Nepomniachtchi"
);
const player6 = new Player(
    [
        2723, 2723, 2726, 2728, 2728, 2728, 2728, 2728, 2728, 2728, 2728, 2749,
        2749, 2749, 2749, 2759, 2759, 2759, 2759, 2759, 2759, 2754, 2770, 2770,
        2804, 2804, 2804, 2804, 2804, 2804, 2793, 2793, 2778, 2778, 2785, 2785,
        2785, 2785, 2785, 2785, 2785, 2785, 2786, 2777, 2777, 2777, 2777, 2777,
        2763, 2759,
    ],
    "Ali Reza Firouzja"
);
const player7 = new Player(
    [
        2760, 2765, 2770, 2770, 2770, 2770, 2770, 2770, 2770, 2770, 2770, 2770,
        2770, 2770, 2770, 2770, 2770, 2770, 2770, 2772, 2772, 2778, 2778, 2772,
        2772, 2772, 2772, 2778, 2778, 2766, 2775, 2773, 2773, 2771, 2774, 2760,
        2760, 2760, 2766, 2761, 2760, 2760, 2765, 2769, 2769, 2753, 2753, 2752,
        2752, 2757,
    ],
    "Wesley So"
);

const player8 = new Player(
    [
        2758, 2758, 2758, 2758, 2758, 2758, 2758, 2758, 2758, 2758, 2758, 2758,
        2758, 2758, 2758, 2758, 2758, 2758, 2758, 2758, 2758, 2760, 2760, 2752,
        2752, 2752, 2752, 2756, 2756, 2753, 2754, 2754, 2754, 2745, 2747, 2743,
        2743, 2743, 2743, 2743, 2739, 2739, 2739, 2739, 2739, 2745, 2745, 2745,
        2745, 2752,
    ],
    "Linier Dominguez"
);

const player9 = new Player(
    [
        2754, 2752, 2752, 2752, 2752, 2752, 2752, 2752, 2752, 2752, 2752, 2752,
        2752, 2757, 2757, 2757, 2757, 2757, 2757, 2757, 2757, 2758, 2743, 2743,
        2743, 2743, 2743, 2747, 2747, 2747, 2747, 2747, 2747, 2747, 2747, 2747,
        2747, 2747, 2747, 2747, 2747, 2747, 2750, 2750, 2750, 2750, 2750, 2750,
        2750, 2750,
    ],
    "Serjey Karjakin"
);

const player10 = new Player(
    [
        2769, 2768, 2763, 2763, 2764, 2764, 2764, 2764, 2764, 2764, 2764, 2764,
        2764, 2764, 2764, 2776, 2776, 2780, 2780, 2776, 2776, 2777, 2774, 2774,
        2772, 2772, 2772, 2771, 2773, 2761, 2761, 2760, 2760, 2764, 2764, 2764,
        2764, 2764, 2780, 2768, 2768, 2768, 2772, 2775, 2769, 2760, 2760, 2752,
        2754, 2749,
    ],
    "Anish Giri"
);

const player11 = new Player(
    [
        2757, 2758, 2755, 2753, 2753, 2753, 2753, 2753, 2753, 2753, 2753, 2753,
        2753, 2753, 2753, 2753, 2753, 2753, 2753, 2753, 2753, 2753, 2753, 2751,
        2751, 2751, 2751, 2751, 2751, 2751, 2751, 2756, 2756, 2756, 2756, 2754,
        2754, 2754, 2754, 2754, 2754, 2754, 2754, 2754, 2754, 2754, 2754, 2748,
        2748, 2748,
    ],
    "Viswanathan Anand"
);

const player12 = new Player(
    [
        2520, 2527, 2557, 2558, 2558, 2558, 2558, 2558, 2568, 2568, 2588, 2588,
        2591, 2591, 2591, 2591, 2591, 2591, 2591, 2591, 2602, 2607, 2630, 2639,
        2664, 2664, 2664, 2655, 2654, 2667, 2675, 2686, 2672, 2693, 2700, 2698,
        2696, 2696, 2690, 2699, 2700, 2700, 2690, 2690, 2701, 2717, 2717, 2721,
        2738, 2743,
    ],
    "Vincent Keymer"
);

const player13 = new Player(
    [
        2586, 2602, 2602, 2608, 2608, 2608, 2608, 2608, 2608, 2608, 2608, 2608,
        2608, 2608, 2608, 2608, 2608, 2608, 2608, 2608, 2608, 2617, 2618, 2610,
        2612, 2612, 2612, 2619, 2624, 2642, 2642, 2648, 2661, 2676, 2687, 2678,
        2684, 2684, 2690, 2691, 2688, 2688, 2690, 2690, 2707, 2727, 2738, 2741,
        2740, 2743,
    ],
    "Praggnanandhaa Rameshbabu"
);

const player14 = new Player(
    [
        2721, 2721, 2721, 2726, 2726, 2726, 2726, 2726, 2726, 2726, 2726, 2726,
        2726, 2726, 2726, 2726, 2726, 2726, 2726, 2726, 2726, 2727, 2727, 2727,
        2727, 2727, 2727, 2723, 2723, 2723, 2723, 2714, 2714, 2710, 2710, 2724,
        2730, 2730, 2730, 2730, 2731, 2731, 2712, 2719, 2723, 2716, 2716, 2715,
        2737, 2742,
    ],
    "Vidiit Gujrathi"
);

const player15 = new Player(
    [
        2690, 2674, 2674, 2676, 2676, 2676, 2676, 2676, 2676, 2676, 2676, 2676,
        2676, 2676, 2676, 2676, 2676, 2698, 2698, 2698, 2698, 2695, 2701, 2706,
        2701, 2701, 2701, 2701, 2699, 2699, 2716, 2701, 2701, 2721, 2721, 2720,
        2719, 2719, 2728, 2726, 2730, 2734, 2716, 2719, 2702, 2707, 2707, 2732,
        2742, 2740,
    ],
    "Parham Maghsoodloo"
);

const player16 = new Player(
    [
        2725, 2732, 2732, 2732, 2732, 2732, 2732, 2732, 2732, 2732, 2732, 2732,
        2732, 2732, 2732, 2732, 2732, 2732, 2725, 2725, 2725, 2725, 2725, 2729,
        2729, 2729, 2729, 2729, 2729, 2727, 2727, 2727, 2727, 2727, 2722, 2722,
        2722, 2722, 2722, 2722, 2722, 2722, 2722, 2726, 2726, 2726, 2726, 2729,
        2729, 2740,
    ],
    "Wei Yi"
);

const player17 = new Player(
    [
        2544, 2575, 2563, 2559, 2559, 2559, 2559, 2559, 2559, 2559, 2559, 2559,
        2559, 2559, 2559, 2559, 2567, 2567, 2567, 2567, 2597, 2626, 2634, 2627,
        2629, 2632, 2633, 2660, 2675, 2675, 2681, 2689, 2689, 2725, 2728, 2718,
        2722, 2722, 2701, 2701, 2701, 2701, 2702, 2710, 2704, 2712, 2712, 2713,
        2727, 2738,
    ],
    "Arjun Erigaisi"
);

const player18 = new Player(
    [
        2780, 2770, 2770, 2767, 2778, 2778, 2778, 2778, 2778, 2778, 2784, 2784,
        2784, 2784, 2784, 2758, 2758, 2760, 2760, 2749, 2751, 2763, 2763, 2766,
        2761, 2761, 2761, 2761, 2758, 2750, 2760, 2760, 2757, 2757, 2747, 2736,
        2737, 2737, 2737, 2736, 2741, 2742, 2747, 2739, 2739, 2727, 2727, 2734,
        2731, 2734,
    ],
    "Maxime Vachier-Lagrave"
);

const player19 = new Player(
    [
        2758, 2758, 2755, 2753, 2753, 2753, 2753, 2753, 2753, 2753, 2757, 2743,
        2743, 2743, 2743, 2729, 2729, 2729, 2729, 2738, 2738, 2756, 2756, 2756,
        2760, 2760, 2760, 2750, 2750, 2750, 2750, 2750, 2740, 2731, 2731, 2731,
        2729, 2729, 2729, 2724, 2724, 2724, 2732, 2732, 2732, 2726, 2726, 2731,
        2732, 2732,
    ],
    "Duda Jan-Krzysztof"
);

const player20 = new Player(
    [
        2777, 2777, 2777, 2777, 2777, 2777, 2777, 2777, 2777, 2777, 2777, 2777,
        2777, 2777, 2777, 2777, 2777, 2776, 2776, 2778, 2778, 2775, 2773, 2773,
        2764, 2764, 2764, 2758, 2742, 2742, 2745, 2745, 2745, 2745, 2745, 2745,
        2745, 2745, 2745, 2745, 2745, 2745, 2736, 2736, 2736, 2732, 2732, 2732,
        2732, 2732,
    ],
    "Alexander Grischuk"
);

const players = [
    player1,
    player2,
    player3,
    player4,
    player5,
    player6,
    player7,
    player8,
    player9,
    player10,
    player11,
    player12,
    player13,
    player14,
    player15,
    player16,
    player17,
    player18,
    player19,
    player20,
];

export default players.map((player) => ({
    ratings: player.getRatings(),
    name: player.getName(),
}));
